//Production
export var baseUrl = "http://www.ileadnam.com/LBCBranches/api";

//Development
//export var baseUrl = "http://lbcusamarketingtv.azurewebsites.net/api";
//export var baseUrl = "http://192.168.10.169";
